<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/regions`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование области</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="id" class="form-label col-md-3">
            ID
          </label>
          <div class="col-md-9">
            <input class="form-control" id="id" type="number"
                   min="0" step="1"
                   v-model="region.id">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-3">
            Наименование
          </label>
          <div class="col-md-9">
            <input class="form-control" id="name" type="text" v-model="region.nameRu">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="mealAmount" class="form-label col-md-3">
            Сумма питания
          </label>
          <div class="col-md-9">
            <input class="form-control" id="mealAmount" type="number" min="0"
                   v-model="region.mealAmount">
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="page-footer justify-content-end" v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import regionService from "@/services/regionService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    regionId() {
      return +this.$route.params.id;
    }
  },
  data() {
    return {
      isLoading: false,
      region: {
        id: null,
        nameRu: null,
        mealAmount: null
      }
    };
  },
  methods: {
    init() {
      if (this.regionId === 0) {
        this.region = {
          id: null,
          nameRu: null
        };
      } else {
        this.findById(this.regionId);
      }
    },
    async findById(regionId) {
      this.isLoading = true;
      this.region = await regionService.findById(regionId);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.region = await regionService.save(this.region);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
</style>
